import { render, staticRenderFns } from "./CopyProduct.vue?vue&type=template&id=5ee43078&"
import script from "./CopyProduct.vue?vue&type=script&lang=ts&"
export * from "./CopyProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports